// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterHeader.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * FilterHeader component
 */

import { FIELDS as fieldsConstants } from 'logic/data/Izenda.ReportDesignerConstants';
import React from 'react';
import m from 'mobx-react';
import classnames from 'classnames';
import CrossFiltering from 'modules/CrossFiltering/Izenda.CrossFiltering';
import connect from 'share/enhancers/Izenda.Connect';
import CrossFilterSetting from 'modules/CrossFiltering/Izenda.CrossFilterSetting';
import constants from 'logic/data/Izenda.ReportsConstants';

const FilterHeader = ({
  store,
  showFreeze,
  reportViewerUIStore,
  authorization,
  authorizationConstants,
  collapseToggle,
  openPopup
}) => {
  let reportFilters = store.reportFilters || {};
  let headerButtonClass = classnames('u_table izenda-FilterHeader__headerButton',
    {
      'header-button': showFreeze
    });

  let showCrossFilteringOption = authorization.checkPrivileges([
    authorizationConstants.PERMISSION_KEY.FullReportAndDashboardAccess,
    authorizationConstants.PERMISSION_KEY.ReportsFilterPropertiesCrossFiltering,
  ], authorizationConstants.PERMISSION_OPERATOR.Or);

  const addNewFilter = () => {
    let defaultData = {
      sourceFieldVisible: true,
      sourceFieldFilterable: true
    };
    reportFilters.addFilter.call(reportFilters, defaultData);
    store.reportStore.model.markDirty();
  };

  const onClickFreeze = () => {
    reportViewerUIStore.doesFreeze = !reportViewerUIStore.doesFreeze;
  };

  const onChangeVisible = (e: Object) => {
    reportFilters.setVisible(e.target.checked);
  };

  const onCrossFilteringOptionClick = () => {
    openPopup(CrossFilterSetting, {
      store: store
    });
  };

  const removePill = (pill: Object) => store.removePill.call(store, pill);
  const removeAllPills = () => store.removeAllPills.call(store);
  const resetCrossFilterDefaultValue = () => store.resetCrossFilterDefaultValue.call(store);
  const freezeLabelBtn = reportViewerUIStore.doesFreeze ? constants.UNFREEZE_BTN_LABEL : constants.FREEZE_BTN_LABEL;

    return (
      <div className="u_table izenda-FilterHeader u_fullWidth">
        <div className="u_tableCell u_paddingRight u_alignMiddle"
        onClick={collapseToggle}>
          <i className='icon-toggle-thick' />
          <strong>{fieldsConstants.FILTERS_HEADER_LABEL}</strong>
        </div>
        <div className='u_tableCell u_alignMiddle u_textNoWrap'>
          <label className="checkbox-inline">
            <input type="checkbox"
              checked={reportFilters.visible}
              onChange={onChangeVisible} />
            {fieldsConstants.SHOW_FILTERS_LABEL}
          </label>
        </div>
        <div className='u_tableCell u_alignMiddle u_fullWidth izenda-FilterHeader__CrossFilteringContainer'>
          <CrossFiltering
            hadSetting={store.reportBody.hadCrossFilteringSetting}
            crossFilteringDetail={store.reportBody.crossFilteringDetail}
            showCrossFilteringOption={showCrossFilteringOption}
            enableCrossFilteringOption={store.reportBody.enableCrossFiltering}
            enableDeleteAll={store.reportBody.enableDeleteAll}
            removeCrossFiltering={removePill}
            removeAllCrossFiltering={removeAllPills}
            onCrossFilteringOptionClick={onCrossFilteringOptionClick}
            resetDefaultValue={resetCrossFilterDefaultValue}/>
        </div>
        <div className={headerButtonClass}>
        <button className='btn btn-primary' onClick={addNewFilter}>
          {fieldsConstants.ADD_FILTER_LABEL}
          </button>
        {showFreeze && (
          <button className="btn btn-primary btn-freeze u_marginLeft" onClick={onClickFreeze}>
            {freezeLabelBtn}
          </button>
        )}
        </div>
      </div>
    );
      };

export default connect()(FilterHeader);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.FilterHeader.js